import React, { useRef, useState } from "react";

import CategoriesCard from "../../CategoriesCard";
import useCategories from "../../../../utils/useCategories";
import SearchField from "../../CommonSearchComponents/SearchField";
import TickerAnimation from "../../TickerAnimation";
/**

@param {Array} props.sortedCategories,  - Sorting of category array
@param {Array} props.selectedCategories - Array of categories
@param {boolean} props.isLoading - Is something relevant loading right now (loading state)
@param {String} props.Title - Main title text to display at the top of popup
@param {String} props.SubTitle - SubTitle text to display on popup
 @param {string} [props.TitleFontcolor] - Font colour for Main title 
 @param {string} [props.TextSize] - Font size class for Main title eg:- "font-sm", "font-md", "font-lg"
  @param {string} [props.SubTitleTextSize] - Font size class for SubTitle eg:- "font-sm", "font-md", "font-lg"
   @param {string} [props.TitleFontWeight] - Font weight class for MainTitle eg:- "font-semibold" ."font-normal"
*/
const CategoriesEdit = ({
  type,
  sortedCategories,
  selectedCategories,
  handleCategorySelect,
  Title,
  SubTitle,
  TextSize,
  TitleFontcolor,
  SubTitleFontcolor,
  SubTitleTextSize,
  TitleFontWeight,
  SubTitleFontWeight,
  isPreview = false,
  flow,
}) => {
  const categoryMapper = useCategories();
  const CategoriesData = Array.isArray(sortedCategories)
    ? sortedCategories.filter((item) => item.active === "Y")
    : [];

  const searchRef = useRef(null);
  const [searchText, setSearchText] = useState("");

  if (isPreview) {
    return (
      <div className="flex flex-col bg-primary-card rounded-border-radius-md gap-gap-md py-padding-md w-width-full">
        <div className="px-padding-md">
          <div className="text-text-primary font-semibold text-font-md">
            {Title}
          </div>
        </div>

        <div className="overflow-auto max-h-category-popup-height px-padding-md w-width-full">
          <div className="flex flex-col gap-gap-md w-width-full">
            {selectedCategories?.map((categoryName, index) => {
              const category = CategoriesData.find(
                (cat) => cat.name === categoryName,
              );

              return (
                <div
                  key={index}
                  className="bg-primary-nav rounded-border-radius-md flex w-width-full"
                >
                  <div className="p-padding-sm flex items-center bg-text-primary rounded-l-border-radius-md">
                    <img
                      className="h-icon-lg w-icon-lg flex-shrink-0"
                      src={categoryMapper(categoryName)}
                      alt="category"
                    />
                  </div>

                  <div className="w-full flex flex-col justify-center pl-padding-sm min-w-0">
                    <p className="text-text-primary truncate text-font-sm font-semibold">
                      <TickerAnimation text={categoryName} />
                    </p>

                    {category?.description && (
                      <p className="text-text-secondary text-font-xs truncate">
                        <TickerAnimation text={category.description} />
                      </p>
                    )}
                  </div>

                  <div className="px-padding-sm"></div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div
        className={`bg-primary-card py-padding-md pl-padding-md rounded-border-radius-md relative ${flow === "switch_account" ? "opacity-light-opacity" : "opacity-base-opacity"}`}
      >
        <div>
          <p
            className={` text-${TitleFontcolor} text-${TextSize} font-${TitleFontWeight}`}
          >
            {Title}
          </p>
          <p
            className={` text-${SubTitleFontcolor} text-${SubTitleTextSize} font-${SubTitleFontWeight} mt-margin-xs mr-margin-md`}
          >
            {SubTitle}
          </p>
        </div>
        <div className="mt-margin-md mr-margin-md">
          <SearchField
            searchText={searchText}
            searchRef={searchRef}
            placeholder="Search category"
            onInput={(value) => setSearchText(value)}
            isDisabled={flow === "switch_account" ? true : false}
            searchBgColor="var(--primary-bg)"
          />
        </div>
        <div className="max-h-category-popup-height overflow-y-auto mt-margin-md gap-gap-md flex flex-col  ">
          {CategoriesData?.filter((cat) =>
            cat?.name?.toLowerCase().includes(searchText.toLowerCase()),
          ).map((category, index) => {
            const isSelected = selectedCategories?.includes(
              type === "CategoryCreate" ? category.id : category.name,
            );

            return (
              <CategoriesCard
                key={index}
                handledata={category}
                category_url={categoryMapper(category.name)}
                SelectedbackgroundColour={
                  isSelected ? "positive-bg" : "primary-nav"
                }
                handleCategorySelect={
                  type === "CategoryCreate"
                    ? () => handleCategorySelect(category)
                    : handleCategorySelect
                }
                logoIcon={
                  isSelected
                    ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                    : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg"
                }
                categoryNameColour="text-primary"
                categoryTextSize="font-sm"
                categoryFontWeight="semibold"
                flow={flow}
              />
            );
          })}
        </div>
      </div>
    </>
  );
};

export default CategoriesEdit;
